import { AppLink } from "@iyk/react-router/client"
import { useLocation } from "react-router"
import { AppRoutes } from "../../../AppRoutes.ts"
import { useTrackViewWhenSeen } from "../../analytics/hooks/useTrackViewWhenSeen.ts"
import { bodyPadding, Container, formatDate, Header, LockedUnlock } from "../../ui/components/UnlockCard.tsx"
import type { UiUnlock } from "../../UiUnlock.ts"

type LockedProps = {
  content: UiUnlock.Locked.App
  locale: string
}

const Locked = ({ content, locale }: LockedProps) => (
  <LockedUnlock
    id={content.id}
    title={content.name}
    caption={content.description}
    world={content.world}
    createdAt={content.createdAt}
    policy={content.policy}
    locale={locale}
  />
)

type UnlockedProps = {
  content: UiUnlock.Unlocked.App
  locale: string
}

const Unlocked = ({ content, locale }: UnlockedProps) => {
  const { id, name, description, iconUrl, world, createdAt } = content
  const formattedCreatedAt = formatDate(createdAt, locale)

  const location = useLocation()
  const viewRef = useTrackViewWhenSeen(id)

  return (
    <Container key={id} ref={viewRef}>
      <Header world={world} title={name} date={formattedCreatedAt} />
      <AppLink
        to={AppRoutes.worlds.unlocks.app(world.slug, id, location.pathname)}
        style={{ paddingLeft: bodyPadding.left, paddingRight: bodyPadding.right }}
      >
        <div className="bg-grayA-2 border border-grayA-3 aspect-video w-full rounded-md flex flex-col items-center justify-center">
          <img src={iconUrl} alt={name} className="size-16 rounded-[22%] object-cover shrink-0" />
          <div className="text-center pt-5">
            <p className="text-sm">{name}</p>
            <p className="text-xs mt-1 text-gray-11">{description}</p>
          </div>
        </div>
      </AppLink>
    </Container>
  )
}

export const AppUnlock = {
  Locked,
  Unlocked
}
